export interface BreadcrumbPoint {
  recorded_at: string;
  latitude: string;
  longitude: string;
  accuracy_m: number | null;
}

const MIN_FIX_INTERVAL_MS = 3 * 1000;
const MAX_BUFFERED_POINTS = 500;

export function toPoint(position: GeolocationPosition): BreadcrumbPoint {
  const { latitude, longitude, accuracy } = position.coords;

  return {
    recorded_at: new Date(position.timestamp).toISOString(),
    // The ingest API stores 8 decimal places (~1mm); trim before it rejects longer values.
    latitude: latitude.toFixed(8),
    longitude: longitude.toFixed(8),
    accuracy_m: accuracy ?? null,
  };
}

export function createBreadcrumbBuffer() {
  let points: BreadcrumbPoint[] = [];
  let lastAcceptedAt = 0;

  return {
    accept(position: GeolocationPosition) {
      if (position.timestamp - lastAcceptedAt < MIN_FIX_INTERVAL_MS) {
        return;
      }
      lastAcceptedAt = position.timestamp;
      points.push(toPoint(position));
      points = points.slice(-MAX_BUFFERED_POINTS);
    },
    drain(): BreadcrumbPoint[] {
      const drained = points;
      points = [];
      return drained;
    },
    restore(unsent: BreadcrumbPoint[]) {
      points = [...unsent, ...points].slice(-MAX_BUFFERED_POINTS);
    },
    get size() {
      return points.length;
    },
  };
}
